<template>
  <div class="r-customer-item">
    <img class="header" v-if="config.imagePath" :src="config.imagePath" alt="" />
    <img class="header" v-else src="../assets/images/defaultHeader.png" alt="" />
    <div class="name">{{config.custName}}</div>
    <div class="tel">{{config.phone}}</div>
    <div class="remark">{{config.remark}}</div>
    <div class="options common-hover"  @click="detail">{{$t('customer.homepage')}}</div>
  </div>
</template>

<script>
export default {
  name: "r-customer-item",
  data() {
    return {};
  },
  methods:{
    //   客户详情
      detail(){
          this.$emit('details',this.config)
      }
  },
  props:{
    config:Object
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-customer-item {
  width: 210px;
  height: 218px;
  background: rgba(10, 77, 204, 0.02);
  border: 1px solid rgba(10, 77, 204, 0.15);
  border-radius: 5px;
  font-family: Roboto;
  text-align: center;
  .header {
    width: 56px;
    height: 56px;
    opacity: 1;
    border-radius: 50%;
    margin: 30px auto 10px;
    display: block;
  }
  .name {
    font-size: 14px;
    font-weight: 500;
    color: #081938;
    line-height: 16px;
    margin-bottom: 4px;
  }
  .tel {
    font-size: 12px;
    font-weight: 400;
    color: #081938;
    line-height: 14px;
    height: 14px;
    margin-bottom: 10px;
  }
  .remark {
    font-size: 12px;
    font-weight: 400;
    color: #d87508;
    line-height: 14px;
    height: 14px;
    margin-bottom: 20px;
  }
  .options {
    width: 92px;
    height: 24px;
    border-radius: 2px;
    background: #e1eaf8;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #0a4dcc;
    line-height: 24px;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/r-customer-item.vue